<template>
    <div class="wide-title" ref="wideText">
        {{ title }}
    </div>
</template>

<script>
import './wide-title.sass'

export default {
    props: {
        title: null,
    },
    methods: {
        resize() {
            const elem = this.$refs.wideText
            elem.style.fontSize = (0.2324 * elem.offsetWidth + 0.336) + 'px';
        },
    },
    async mounted() {
        this.$nextTick(() => {
            this.resize();
            if (window) {    
                window.addEventListener('resize', this.resize);
            }
        });
    },
    beforeDestroy() {
        if (window) {
            window.removeEventListener('resize', this.resize);
        }
    },
}
</script>